import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { t } from 'i18next';
import { useApi, useResponsive, useSession } from 'hooks';
import { Home } from 'pages';
import { Button, ModalPortal, Spinner, Text } from 'ui';
import { Modal } from 'templates';
var Vas = function () {
    var _a = useParams(), _b = _a.provider, provider = _b === void 0 ? 'faro' : _b, token = _a.token;
    var navigate = useNavigate();
    var isRecaptchaV3Ready = useApi().isRecaptchaV3Ready;
    var _c = useSession(), isLogging = _c.isLogging, loginVas = _c.loginVas, isLoggedIn = _c.isLoggedIn;
    var isMobile = useResponsive().isMobile;
    var _d = useState(false), showModal = _d[0], setShowModal = _d[1];
    useEffect(function () {
        if (!isRecaptchaV3Ready)
            return;
        console.log('Recaptcha v3 is ready, login VAS user');
        loginVas({ provider: provider, token: token }, {
            onError: function (loginError) {
                console.log({ loginError: loginError });
                if (loginError && typeof loginError === 'object'
                    && 'details' in loginError && typeof loginError.details === 'object'
                    && Array.isArray(loginError.details) && loginError.details.length) {
                    var detail = loginError.details[0];
                    if (detail.field === 'payment.createdAt' && detail.type === 'invalid') {
                        console.log('subscription payment required');
                        setShowModal(true);
                    }
                }
            },
        });
        document.body.style.overflow = 'hidden';
        return function () {
            document.body.style.overflow = 'visible';
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isRecaptchaV3Ready]);
    useEffect(function () {
        if (!isLoggedIn)
            return;
        navigate('/', { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);
    return (_jsxs(_Fragment, { children: [showModal && (_jsx(ModalPortal, { children: _jsxs(Modal, { modalStyle: {
                        width: '100%',
                        maxWidth: 461,
                    }, containerStyle: {
                        padding: isMobile ? 32 : 60,
                        gap: isMobile ? 24 : 32,
                    }, children: [_jsx(Text, { size: 'xl', weight: 'semibold', color: 'headline', align: 'center', children: t('vas:paymentRequired.title') }), _jsx(Text, { align: 'center', children: t('vas:paymentRequired.description') }), _jsx(Button, { size: 'large', isFull: true, onClick: function () {
                                setShowModal(false);
                                navigate('/', { replace: true });
                            }, children: t('common:ok') })] }) })), isLogging && (_jsx("div", { style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    backgroundColor: 'rgba(0,0,0, .4)',
                    zIndex: 99,
                    display: 'grid',
                    placeItems: 'center',
                }, children: _jsx(Spinner, { size: 50 }) })), _jsx(Home, {})] }));
};
export default Vas;
